import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSettings } from './api';
import { site as fallbackSite } from '../data/mock';

const SettingsContext = createContext({ settings: null, loading: true });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const s = await getSettings();
        if (alive && s && s.company) setSettings(s);
      } catch (e) {
        // silent fallback
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const value = { settings, loading };
  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export function useSiteInfo() {
  const { settings } = useContext(SettingsContext);
  const company = settings?.company || {};
  const socials = settings?.socials || {};
  return {
    name: company.name || fallbackSite.name,
    tagline: company.tagline || fallbackSite.tagline,
    email: company.email || fallbackSite.email,
    phone: company.phone || fallbackSite.phone,
    phoneRaw: company.phoneRaw || fallbackSite.phoneRaw,
    address: company.address || fallbackSite.address,
    hours: company.hours || fallbackSite.hours,
    socials: { ...fallbackSite.socials, ...socials },
  };
}
